import {Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {UtilsService} from '../services/utils.service';
import {fromEvent, Subscription} from 'rxjs';
import {delay, startWith} from 'rxjs/operators';

@Directive({
  selector: '[appAnimatedDigit]'
})
export class AnimatedDigitDirective implements OnChanges, OnDestroy {

  @Input() appAnimatedDigit;

  private elementPos: number;
  private elementHeight: number;

  private scrollPos: number;
  private windowHeight: number;
  private readonly subscriptions: Subscription = new Subscription();

  constructor(private elementRef: ElementRef, private utilsService: UtilsService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.appAnimatedDigit && !isNaN(this.appAnimatedDigit) && this.utilsService.isPlatformBrowser) {
      this.elementRef.nativeElement.textContent = 0;
      this.subscribe();
    } else {
      this.elementRef.nativeElement.textContent = this.appAnimatedDigit;
    }
  }

  private counterFunc(endValue, durationMs, element) {

    const stepCount = Math.abs(durationMs / 12);
    const valueIncrement = (endValue - 0) / stepCount;
    const sinValueIncrement = Math.PI / stepCount;

    let currentValue = 0;
    let currentSinValue = 0;

    function step() {
      currentSinValue += sinValueIncrement;
      currentValue += valueIncrement * Math.sin(currentSinValue) ** 2 * 2;

      element.nativeElement.textContent = Math.abs(Math.floor(currentValue));

      if (currentSinValue < Math.PI) {
        window.requestAnimationFrame(step);
      }
    }

    step();
  }

  saveDimensions() {
    this.elementPos = this.getOffsetTop(this.elementRef.nativeElement);
    this.elementHeight = this.elementRef.nativeElement.offsetHeight;
    this.windowHeight = window.innerHeight;
  }

  saveScrollPos() {
    this.scrollPos = window.scrollY;
  }

  getOffsetTop(element: any) {
    let offsetTop = element.offsetTop || 0;
    if (element.offsetParent) {
      offsetTop += this.getOffsetTop(element.offsetParent);
    }
    return offsetTop;
  }

  checkVisibility() {
    if (this.isVisible()) {
      // double check dimensions (due to async loaded contents, e.g. images)
      this.saveDimensions();
      if (this.isVisible()) {
        this.unsubscribe();
        this.counterFunc(Number(this.appAnimatedDigit), 1000, this.elementRef);
      }
    }
  }

  isVisible() {
    return this.scrollPos >= this.elementPos || (this.scrollPos + this.windowHeight) >= (this.elementPos + this.elementHeight);
  }

  subscribe() {
    this.subscriptions.add(
      fromEvent(window, 'scroll').pipe(startWith(null), delay(3000))
        .subscribe(() => {
          this.saveScrollPos();
          this.checkVisibility();
        })
    );
    this.subscriptions.add(
      fromEvent(window, 'resize').pipe(startWith(null), delay(3000))
        .subscribe(() => {
          this.saveDimensions();
          this.checkVisibility();
        })
    );
  }

  unsubscribe() {
    this.subscriptions.unsubscribe();
  }

  ngOnDestroy() {
    this.unsubscribe();
  }
}
